import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
	forTabletLandscapeOnly,
	forDesktopUp,
	forTabletPortraitUp,
} from '../../../utils/mediaqueries';
import { getImageUrl, IMAGE_SIZES } from '../../../reducer/cms';
import { isSchool } from '../../../utils/helperFunctions';

import ValidateEmail from '../../customer/ValidateEmail';

export class Banner extends Component {
	static propTypes = {
		showOnMobile: PropTypes.bool,
	};

	render() {
		const { bannerImg, children } = this.props;

		const smallImg = getImageUrl(bannerImg, IMAGE_SIZES.BANNER_SMALL);
		const mediumImg = getImageUrl(bannerImg, IMAGE_SIZES.BANNER_MEDIUM);
		const largeImg = getImageUrl(bannerImg, IMAGE_SIZES.BANNER_LARGE);

		return (
			<>
				{!isSchool() && <ValidateEmail />}
				<DesktopContainer>
					<BannerImageContainer>
						<BannerImage
							smallImg={smallImg}
							mediumImg={mediumImg}
							largeImg={largeImg}
						/>
					</BannerImageContainer>
					<BannerText>{children}</BannerText>
				</DesktopContainer>
			</>
		);
	}
}

const BannerImageContainer = styled.div`
	${forTabletPortraitUp`
		width: 50%;
	`}
`;

const BannerImage = styled.div`
	display: none;
	width: 50%;

	${forTabletPortraitUp`
		background: url(${props => props.smallImg}) center;
		display: block;
		width: 100%;
		height: 210px;
		border-bottom-right-radius: 168px;
		background-size: cover;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
	`}

	${forTabletLandscapeOnly`
		background: url(${props => props.mediumImg}) center;
	`}

	${forDesktopUp`
		background: url(${props => props.largeImg}) center;
	`}
`;

const DesktopContainer = styled.div`
	background-color: white;
	width: inherit;
	display: flex;
	display: -webkit-inline-box;
	position: relative;
	width: 100%;

	h2 {
		margin-top: 0;
	}
`;

const BannerText = styled.div`
	padding: 2em 2em 0 2em;
	text-align: center;
	width: 100%;

	> h1 {
		display: none;
	}

	${forTabletPortraitUp`
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 50%;
		padding: 0 0 0 4em;
		text-align: left;

		> h1 {
			display: block;
		}
	`}
`;
